"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.setupFrameworkComponents = void 0;
const tslib_1 = require("tslib");
const React = tslib_1.__importStar(require("react"));
const weakMap = new WeakMap();
const setupFrameworkComponents = (adaptableApi) => {
    adaptableApi.internalApi
        .getAdaptableInstance()
        ._onIncludeFired('FrameworkComponentChange', ({ command, frameworkComponent, containerDomNode, componentType }) => {
        if (command === 'create') {
            try {
                adaptableApi.logInfo(`Mounting custom framework component ${componentType}`, containerDomNode);
                const ReactComponent = frameworkComponent;
                const unmount = adaptableApi.internalApi
                    .getAdaptableInstance()
                    .renderReactRoot(React.createElement(ReactComponent, { adaptableApi: adaptableApi }), containerDomNode);
                weakMap.set(containerDomNode, unmount);
            }
            catch (err) {
                adaptableApi.logError(`Cannot correctly mount custom framework component ${componentType}`, err);
            }
        }
        else {
            adaptableApi.logInfo(`Unmounting custom framework component  ${componentType}`, containerDomNode);
            try {
                const unmount = weakMap.get(containerDomNode);
                weakMap.delete(containerDomNode);
                if (!unmount) {
                    throw 'Cannot find render root for given node.';
                }
                unmount();
            }
            catch (err) {
                adaptableApi.logError(`Cannot correctly unmount custom framework component ${componentType}`, err);
            }
        }
    });
};
exports.setupFrameworkComponents = setupFrameworkComponents;
